import React from 'react';
import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
} from '@packages/utilities/data-utils';

const TabsContent = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const Tag = getInPojo(data, ['tag']) as React.ElementType;
    const tabsContentClasses = classes.push('w-tab-content');
    return (
      <Tag {...generateAttributes(attributes, tabsContentClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Tabs Content',
  constraints: {
    parent: [
      {
        is: 'TabsWrapper',
        rule: 'ExactlyOne',
      },
    ],
    children: [
      {
        is: 'TabsPane',
        name: 'Non-Tab-Pane Item',
        rule: 'RequireOnly',
      },
      {
        is: 'TabsPane',
        rule: 'AtLeastOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Slider'), iconName('Mask')),
  },
  showEmpty: true,
  render: TabsContent,
  fields: {
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
    children: TListOfElement,
  },
});

export default config;
